import _get from "lodash/get";
import styled, { css } from 'styled-components';
import { rem } from 'polished';
import footerTheme from '../../styles/footerTheme';
var FooterContentWrapper = styled.footer.withConfig({
  displayName: "FooterContentWrapper",
  componentId: "sc-17lrryz-0"
})(["background-image:linear-gradient( to bottom,", " 0,", " 100% );padding:", " 0 ", ";position:relative;width:100%;z-index:1;", ""], function (_ref) {
  var theme = _ref.theme;
  return _get(theme, 'footer.defaultFooter.backgroundStart', footerTheme.footer.defaultFooter.backgroundStart);
}, function (_ref2) {
  var theme = _ref2.theme;
  return _get(theme, 'footer.defaultFooter.backgroundEnd', footerTheme.footer.defaultFooter.backgroundEnd);
}, rem(40), rem(60), function (_ref3) {
  var showDivider = _ref3.showDivider,
      theme = _ref3.theme;
  return showDivider && css(["border-top:1px solid ", ";"], _get(theme, 'footer.defaultFooter.dividerColor', footerTheme.footer.defaultFooter.dividerColor));
});
export default FooterContentWrapper;